export default __webpack_public_path__ + "static/media/ledgern.b3e67411.png";